import BeCuponUtils from "@/utils/Utils";

export default class NotificationBody {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        notificationBodyRetrieve(id: ${id}) {
          id
          title
          text
          created
          logo {
            id 
            url
          }
          companies {
            id
            name
            description
          }          
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    response.data.data.notificationBodyRetrieve.compressed = {
      companies: response.data.data.notificationBodyRetrieve.companies     
    };

    response.data.data.notificationBodyRetrieve.companies = response.data.data.notificationBodyRetrieve.companies.map(company => company.id);
    
    return response.data.data.notificationBodyRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        notificationBodyList {
          results {
            id
            title
            text
            created
            logo {
              id
              url
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    for(var i = 0; i < response.data.data.notificationBodyList.results.length; i++) {
       response.data.data.notificationBodyList.results[i].created = BeCuponUtils.formatDateTime(
         response.data.data.notificationBodyList.results[i].created
       );
    }

    return response.data.data.notificationBodyList.results.reverse();
  }

  // static async filter(axios, region) {
  //   const response = await axios.post(
  //     '/graphql/',
  //     `query{
  //       cityList (region: ${region}){
  //         results {
  //           id
  //           name
  //           latitude
  //           longitude
  //           region {
  //             id
  //             name
  //           }
  //         }
  //       }
  //     }`,
  //     {
  //       headers: {
  //         'Content-Type': 'application/graphql'
  //       }
  //     }
  //   );
  //   return response.data.data.cityList.results.reverse();
  // }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteNotificationBody(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteNotificationBody.ok;
  }

  static async create(axios, title, text, logo) {
    const logoField = (logo !== -1) ? `logo: ${logo},` : ``;
    
    const response = await axios.post(
      '/graphql/',
      `mutation{
        createNotificationBody(newNotificationbody: {
          ${logoField}
          title: "${title}", 
          text: "${text}"
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createNotificationBody.ok;
  }


  static async edit(axios, id, title, text, logo) {
    const logoField = (logo !== -1) ? `logo: ${logo},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateNotificationBody(newNotificationbody: {
          ${logoField}
          id: ${id},
          title: "${title}", 
          text: "${text}"
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateNotificationBody.ok;
  }

}